import { render, staticRenderFns } from "./TaskDetailPage.vue?vue&type=template&id=49239754&scoped=true"
import script from "./TaskDetailPage.vue?vue&type=script&lang=js"
export * from "./TaskDetailPage.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailPage.vue?vue&type=style&index=0&id=49239754&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49239754",
  null
  
)

export default component.exports